import { theme } from '@acorns/grove'
import { Page as BasePage } from '@acorns/web-components'
import styled from 'styled-components'

export const Page = styled(BasePage)`
  > div {
    justify-content: center;
    padding-top: 0;
  }

  @media (min-width: ${theme.dimensions.breakpointsSmall + 1}px) {
    margin-top: 30px;

    #page-card {
      padding-top: 80px;

      > div {
        margin: unset;
        padding: unset;
      }
    }
  }
`

export const ContentContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-grow: 1;
  flex-direction: column;

  @media (min-width: ${theme.dimensions.breakpointsSmall + 1}px) {
    max-width: 340px;
    margin: 0 auto 80px;
  }
`

export const Headline = styled.p<{ hasExtraSpacing: boolean }>`
  font-weight: 600;
  font-size: 22px;
  line-height: 30px;
  margin-top: 0;
  margin-bottom: ${(props) => (props.hasExtraSpacing ? 30 : 10)}px;
  text-align: center;
`

export const Subtitle = styled.p`
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: ${theme.colors.primarySlate};
  text-align: center;

  @media (min-width: ${theme.dimensions.breakpointsSmall + 1}px) {
    margin-bottom: 30px;
  }
`

export const ImageContainer = styled.div`
  max-height: 140px;
  height: 140px;
  margin: 0 auto 20px;

  img {
    height: 100%;
  }

  > div {
    height: 100%;
  }

  @media (min-width: ${theme.dimensions.breakpointsSmall + 1}px) {
    margin-bottom: 30px;
  }
`

export const FooterContainer = styled.div`
  padding: 20px 0;
  display: flex;
  gap: 20px;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: ${theme.colors.primaryWhite};

  @media (min-width: ${theme.dimensions.breakpointsSmall + 1}px) {
    padding-top: 30px;
    padding-bottom: 30px;
    border-bottom-left-radius: ${theme.borderRadius.large};
    border-bottom-right-radius: ${theme.borderRadius.large};
  }
`
